import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import clsx from 'clsx'
import { FC, ReactNode } from 'react'

import { cn } from '@/app/utils'

type Props = {
  children?: ReactNode
  buttonRender?: ReactNode
  className?: string
  buttonClassName?: string
  panelClassName?: string
  panelTestId?: string
  defaultOpened?: boolean
}

const AppDisclosure: FC<Props> = ({
  children,
  buttonRender,
  className,
  defaultOpened,
  buttonClassName,
  panelClassName,
  panelTestId
}) => {
  return (
    <Disclosure
      as="div"
      className={clsx(className)}
      defaultOpen={defaultOpened}
    >
      {({ open }) => (
        <>
          <Disclosure.Button
            className={cn(
              'flex w-full items-center justify-between rounded-12 bg-grey-20 px-24 py-22 text-left font-semibold transition-colors text-20',
              'hover:bg-grey-30 focus:outline-none focus-visible:ring',
              'lg:p-12 lg:text-16',
              buttonClassName
            )}
          >
            {buttonRender}

            <span className="pl-10">
              <ChevronDownIcon
                className={clsx(
                  'h-24 w-24 flex-shrink-0 transition-transform',
                  open && '-scale-100'
                )}
              />
            </span>
          </Disclosure.Button>

          <Disclosure.Panel
            className={cn('mt-24', panelClassName)}
            data-testid={panelTestId}
          >
            {children}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default AppDisclosure
